// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const creditBarLabels = "CreditChart__creditBarLabels__bxLdL font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const creditBarPortion = "CreditChart__creditBarPortion__XUpoi";
export const creditChart = "CreditChart__creditChart__ZDZH2";
export const creditMarker = "CreditChart__creditMarker__jXDlF";
export const defaultMarkerTop = "var(--default-marker-top)";
export const excellent = "CreditChart__excellent__ZKxqt";
export const fair = "CreditChart__fair__nYCS5";
export const good = "CreditChart__good__DlduQ";
export const great = "CreditChart__great__jgjvl";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const low = "CreditChart__low__vEsgG";
export const medium = "500";
export const member = "CreditChart__member__QaiYz";
export const others = "CreditChart__others__Ye83T";
export const peers = "CreditChart__peers__MmsKr";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "CreditChart__textCenter__-VCKL";
export const tooltipContainer = "CreditChart__tooltipContainer__QmsCY";